import { renderHook } from "@testing-library/react";

import useResizeObserver from "./useResizeObserver";

describe("useResizeObserver", () => {
  it("should test", () => {
    const ref = { current: undefined };
    const { result } = renderHook(() => useResizeObserver(ref));
    expect(result.current).toBeUndefined();
  });

  it("should test real element", () => {
    const div = document.createElement("div");
    document.body.appendChild(div);
    const ref = { current: div };
    const { result } = renderHook(() => useResizeObserver(ref));
    expect(result.current).toBeUndefined();
  });
});
